<template>
  <ul class="stack">
    <div class="guide-icon guideAnim" v-if="guideShow">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="61.368" height="66.32" viewBox="0 0 61.368 66.32">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_2851" data-name="Rectangle 2851" width="44.978" height="23.632" fill="#fff" stroke="#707070" stroke-width="1"/>
        </clipPath>
      </defs>
      <g id="Group_3408" data-name="Group 3408" transform="translate(-932.5 -6888)">
        <path id="Union_78" data-name="Union 78" d="M16.77,57.936a1.524,1.524,0,0,1-1.141-.523C9.695,50.471,4.817,41.328.858,31.8a8.454,8.454,0,0,1-.669-5.29c.807-2.685,4.353-5,7.241-4.215,2.129.542,3.822,2.75,4.767,4.789V6.1A6.117,6.117,0,0,1,18.3,0a6.009,6.009,0,0,1,6.1,6.1V18.821a5.959,5.959,0,0,1,2.29-.525,5.563,5.563,0,0,1,3.288,1.048,5.083,5.083,0,0,1,1.094,1.337,4.336,4.336,0,0,1,2.452-.858,5.392,5.392,0,0,1,3.242,1.048,5.056,5.056,0,0,1,1.618,2.216,10.127,10.127,0,0,1,2.194-.217c3.153.369,5.268,2.864,6.051,5.86a25.617,25.617,0,0,1,.236,10.341,43.65,43.65,0,0,1-3.167,10.863c-1.469,3.3-3.237,6.068-5.431,7.7a1.524,1.524,0,0,1-.908.306Z" transform="translate(946.603 6896.384)" fill="#fff"/>
        <g id="Mask_Group_80" data-name="Mask Group 80" transform="translate(939.742 6888)" clip-path="url(#clip-path)">
          <g id="Rectangle_2850" data-name="Rectangle 2850" transform="translate(-22.87)" fill="none" stroke="#fff" stroke-width="4">
            <rect width="67.848" height="23.632" rx="11.816" stroke="none"/>
            <rect x="2" y="2" width="63.848" height="19.632" rx="9.816" fill="none"/>
          </g>
        </g>
        <line id="Line_113" data-name="Line 113" x2="16.009" transform="translate(932.5 6899.816)" fill="none" stroke="#fff" stroke-width="4"/>
      </g>
    </svg>
    </div>
    <li
      class="stack-item"
      v-for="(item, index) in pages"
      :style="[transformIndex(index), transform(index)]"
      :key="index"
      @touchmove.stop.capture.prevent="touchmove"
      @touchstart.stop.capture.prevent="touchstart"
      @touchend.stop.capture.prevent="touchend"
      @touchcancel.stop.capture.prevent="touchend"
      @mousedown.stop.capture.prevent="touchstart"
      @mouseup.stop.capture.prevent="touchend"
      @mousemove.stop.capture.prevent="touchmove"
      @mouseout.stop.capture.prevent="touchend"
      @webkit-transition-end="onTransitionEnd(index)"
      @transitionend="onTransitionEnd(index)"
    >
      <!-- <div v-html="item.html"></div> -->
      <div class="img-wrapper">
        <img :src="_.get(item, 'url')" alt="" />
      </div>
    </li>
  </ul>
</template>
<script>
import detectPrefixes from "../utils/detect-prefixes";
export default {
  props: {
    stackinit: {
      type: Object,
      default: []
    },
    pages: {
      // type: Array,
      // default: {}
    }
  },
  mounted() {
    console.log('ager', this.pages)
  },
  data() {
    return {
      guideShow: true,
      basicdata: {
        start: {},
        end: {}
      },
      temporaryData: {
        prefixes: detectPrefixes(),
        offsetY: "",
        poswidth: 0,
        posheight: 0,
        lastPosWidth: "",
        lastPosHeight: "",
        lastZindex: "",
        rotate: 0,
        lastRotate: 0,
        visible: this.stackinit.visible || 3,
        tracking: false,
        animation: false,
        currentPage: this.stackinit.currentPage || 0,
        opacity: 1,
        lastOpacity: 0,
        swipe: false,
        zIndex: 10
      }
    };
  },
  computed: {
    offsetRatio() {
      let width = this.$el.offsetWidth;
      let height = this.$el.offsetHeight;
      let offsetWidth = width - Math.abs(this.temporaryData.poswidth);
      let offsetHeight = height - Math.abs(this.temporaryData.posheight);
      let ratio = 1 - (offsetWidth * offsetHeight) / (width * height) || 0;
      return ratio > 1 ? 1 : ratio;
    },

    offsetWidthRatio() {
      let width = this.$el.offsetWidth;
      let offsetWidth = width - Math.abs(this.temporaryData.poswidth);
      let ratio = 1 - offsetWidth / width || 0;
      return ratio;
    }
  },
  mounted() {
    this.$on("next", () => {
      this.next();
    });
    this.$on("prev", () => {
      this.prev();
    });
    document.addEventListener(
      "touchmove",
      e => {
        // e.preventDefault();
      },
      { passive: false }
    );
  },
  methods: {
    touchstart(e) {
      this.guideShow = false
      if (this.temporaryData.tracking) {
        return;
      }
      // 是否为touch
      if (e.type === "touchstart") {
        if (e.touches.length > 1) {
          this.temporaryData.tracking = false;
          return;
        } else {
          this.basicdata.start.t = new Date().getTime();
          this.basicdata.start.x = e.targetTouches[0].clientX;
          this.basicdata.start.y = e.targetTouches[0].clientY;
          this.basicdata.end.x = e.targetTouches[0].clientX;
          this.basicdata.end.y = e.targetTouches[0].clientY;
          // offsetYtouch
          this.temporaryData.offsetY =
            e.targetTouches[0].pageY - this.$el.offsetParent.offsetTop;
        }
        // pc
      } else {
        this.basicdata.start.t = new Date().getTime();
        this.basicdata.start.x = e.clientX;
        this.basicdata.start.y = e.clientY;
        this.basicdata.end.x = e.clientX;
        this.basicdata.end.y = e.clientY;
        this.temporaryData.offsetY = e.offsetY;
      }
      this.temporaryData.tracking = true;
      this.temporaryData.animation = false;
    },
    touchmove(e) {
      // 记录滑动位置
      if (this.temporaryData.tracking && !this.temporaryData.animation) {
        if (e.type === "touchmove") {
          // e.preventDefault();
          this.basicdata.end.x = e.targetTouches[0].clientX;
          this.basicdata.end.y = e.targetTouches[0].clientY;
        } else {
          // e.preventDefault();
          this.basicdata.end.x = e.clientX;
          this.basicdata.end.y = e.clientY;
        }
        // 计算滑动值
        this.temporaryData.poswidth =
          this.basicdata.end.x - this.basicdata.start.x;
        this.temporaryData.posheight =
          this.basicdata.end.y - this.basicdata.start.y;
        let rotateDirection = this.rotateDirection();
        let angleRatio = this.angleRatio();
        this.temporaryData.rotate =
          rotateDirection * this.offsetWidthRatio * 2 * angleRatio;
      }
    },
    touchend(e) {
      this.temporaryData.tracking = false;
      this.temporaryData.animation = true;
      // 滑动结束，触发判断
      // 判断划出面积是否大于0.4
      if (this.offsetRatio >= 0.4) {
        // 计算划出后最终位置
        let ratio = Math.abs(
          this.temporaryData.posheight / this.temporaryData.poswidth
        );
        this.temporaryData.poswidth =
          this.temporaryData.poswidth >= 0
            ? this.temporaryData.poswidth + 200
            : this.temporaryData.poswidth - 200;
        this.temporaryData.posheight =
          this.temporaryData.posheight >= 0
            ? Math.abs(this.temporaryData.poswidth * ratio)
            : -Math.abs(this.temporaryData.poswidth * ratio);
        this.temporaryData.opacity = 0;
        this.temporaryData.swipe = true;
        this.nextTick();
        // 不满足条件则滑入
      } else {
        this.temporaryData.poswidth = 0;
        this.temporaryData.posheight = 0;
        this.temporaryData.swipe = false;
        this.temporaryData.rotate = 0;
      }
    },
    nextTick() {
      // 记录最终滑动距离
      this.temporaryData.lastPosWidth = this.temporaryData.poswidth;
      this.temporaryData.lastPosHeight = this.temporaryData.posheight;
      this.temporaryData.lastRotate = this.temporaryData.rotate;
      this.temporaryData.lastZindex = 20;
      // 循环currentPage
      this.temporaryData.currentPage =
        this.temporaryData.currentPage === this.pages.length - 1
          ? 0
          : this.temporaryData.currentPage + 1;
      // currentPage切换，整体dom进行变化，把第一层滑动置最低
      this.$nextTick(() => {
        this.temporaryData.poswidth = 0;
        this.temporaryData.posheight = 0;
        this.temporaryData.opacity = 1;
        this.temporaryData.rotate = 0;
      });
    },
    onTransitionEnd(index) {
      let lastPage =
        this.temporaryData.currentPage === 0
          ? this.pages.length - 1
          : this.temporaryData.currentPage - 1;
      // dom发生变化正在执行的动画滑动序列已经变为上一层
      if (this.temporaryData.swipe && index === lastPage) {
        this.temporaryData.animation = true;
        this.temporaryData.lastPosWidth = 0;
        this.temporaryData.lastPosHeight = 0;
        this.temporaryData.lastOpacity = 0;
        this.temporaryData.lastRotate = 0;
        this.temporaryData.swipe = false;
        this.temporaryData.lastZindex = -1;
      }
    },
    prev() {
      this.temporaryData.tracking = false;
      this.temporaryData.animation = true;
      // 计算划出后最终位置
      let width = this.$el.offsetWidth;
      this.temporaryData.poswidth = -width;
      this.temporaryData.posheight = 0;
      this.temporaryData.opacity = 0;
      this.temporaryData.rotate = "-3";
      this.temporaryData.swipe = true;
      this.nextTick();
    },
    next() {
      this.temporaryData.tracking = false;
      this.temporaryData.animation = true;
      // 计算划出后最终位置
      let width = this.$el.offsetWidth;
      this.temporaryData.poswidth = width;
      this.temporaryData.posheight = 0;
      this.temporaryData.opacity = 0;
      this.temporaryData.rotate = "3";
      this.temporaryData.swipe = true;
      this.nextTick();
    },
    rotateDirection() {
      if (this.temporaryData.poswidth <= 0) {
        return -1;
      } else {
        return 1;
      }
    },
    angleRatio() {
      let height = this.$el.offsetHeight;
      let offsetY = this.temporaryData.offsetY;
      let ratio = -1 * ((2 * offsetY) / height - 1);
      return ratio || 0;
    },
    inStack(index, currentPage) {
      let stack = [];
      let visible = this.temporaryData.visible;
      let length = this.pages.length;
      for (let i = 0; i < visible; i++) {
        if (currentPage + i < length) {
          stack.push(currentPage + i);
        } else {
          stack.push(currentPage + i - length);
        }
      }
      return stack.indexOf(index) >= 0;
    },
    // 非首页样式切换
    transform(index) {
      let currentPage = this.temporaryData.currentPage;
      let length = this.pages.length;
      let lastPage =
        currentPage === 0 ? this.pages.length - 1 : currentPage - 1;
      let style = {};
      let visible = this.temporaryData.visible;
      if (index === this.temporaryData.currentPage) {
        return;
      }
      if (this.inStack(index, currentPage)) {
        let perIndex =
          index - currentPage > 0
            ? index - currentPage
            : index - currentPage + length;
        style["opacity"] = "1";
        style["transform"] =
          "translate3D(0,0," +
          -1 * 40 * (perIndex - this.offsetRatio) +
          "px" +
          ")";
        style["zIndex"] = visible - perIndex;
        if (!this.temporaryData.tracking) {
          style[this.temporaryData.prefixes.transition + "TimingFunction"] =
            "ease";
          style[this.temporaryData.prefixes.transition + "Duration"] =
            300 + "ms";
        }
      } else if (index === lastPage) {
        style["transform"] =
          "translate3D(" +
          this.temporaryData.lastPosWidth +
          "px" +
          "," +
          this.temporaryData.lastPosHeight +
          "px" +
          ",0px) " +
          "rotate(" +
          this.temporaryData.lastRotate +
          "deg)";
        style["opacity"] = this.temporaryData.lastOpacity;
        style["zIndex"] = this.temporaryData.lastZindex;
        style[this.temporaryData.prefixes.transition + "TimingFunction"] =
          "ease";
        style[this.temporaryData.prefixes.transition + "Duration"] = 300 + "ms";
      } else {
        style["zIndex"] = "-1";
        style["transform"] =
          "translate3D(0,0," + -1 * visible * 40 + "px" + ")";
      }
      return style;
    },
    // 首页样式切换
    transformIndex(index) {
      if (index === this.temporaryData.currentPage) {
        let style = {};
        style["transform"] =
          "translate3D(" +
          this.temporaryData.poswidth +
          "px" +
          "," +
          this.temporaryData.posheight +
          "px" +
          ",0px) " +
          "rotate(" +
          this.temporaryData.rotate +
          "deg)";
        style["opacity"] = this.temporaryData.opacity;
        style["zIndex"] = 10;
        if (this.temporaryData.animation) {
          style[this.temporaryData.prefixes.transition + "TimingFunction"] =
            "ease";
          style[this.temporaryData.prefixes.transition + "Duration"] =
            (this.temporaryData.animation ? 300 : 0) + "ms";
        }
        return style;
      }
    }
  }
};
</script>
<style lang="scss">
.stack .guide-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999999999;
}
.stack {
  width: 100%;
  height: 100%;
  position: relative;
  perspective: 1000px;
  perspective-origin: 50% 150%;
  -webkit-perspective: 1000px;
  -webkit-perspective-origin: 50% 150%;
  margin: 0;
  padding: 0;
}
.stack-item {
  background: transparent;
  height: 100%;
  width: 100%;

  text-align: center;
  overflow: visible;
  position: absolute;
  opacity: 0;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: auto;
  .img-wrapper {
    cursor: grab;
    transition: all cubic-bezier(0, 0.08, 0.06, 0.99) 1s;
    &:active {
      cursor: grabbing;
    }
  }
}
.our-products-slider {
  .stack-item{
    
   
    &:nth-child(1){
        .img-wrapper{
            transform: rotate(5deg) translateY(39.3px) scale(1.6);
            opacity: 0;
          transition-delay: .1s;
        }
    }
     &:nth-child(2){
        .img-wrapper{
            transform: rotate(-2deg) translateX(200px) translateY(7.7px) scale(1.2);
            transition-delay: .4s;
             opacity: 0;
          
        }
    }
     &:nth-child(3){
        .img-wrapper{
            transform: rotate(-9deg) translateX(-200px) translateY(7.7px) scale(1.2);
            transition-delay: .5s;
              opacity: 0;
            
        }
    }
  }
}
.our-products-slider.is-inview {
  .stack-item{
    
   
    &:nth-child(1){
        .img-wrapper{
           
           
                   transform: rotate(5deg) translateY(39.3px) scale(1); 
                   opacity: 1;
           
        }
    }
     &:nth-child(2){
        .img-wrapper{
          
              
                   transform: rotate(-2deg) translateX(0) translateY(7.7px) scale(1); 
                   opacity: 1;
            
        }
    }
     &:nth-child(3){
        .img-wrapper{
          
             
                   transform: rotate(-9deg) translateX(0) translateY(39.3px) scale(1); 
                   opacity: 1;
            
        }
    }
  }
}
.stack-item img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  pointer-events: none;
}
.stack-container li.move-back {
  /* http://matthewlein.com/ceaser/ */
  -webkit-transition-timing-function: cubic-bezier(
    0.175,
    0.885,
    0.47,
    1
  ); /* older webkit */
  -webkit-transition-timing-function: cubic-bezier(0.175, 0.885, 0.47, 1.515);
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.47, 1.515);
}
</style>
